// extracted by mini-css-extract-plugin
export default {"calculatingLayoutSpinnerContainer":"S22kNLO","calculatingLayoutSpinnerContent":"OGvVrIu","calculatingLayoutSpinnerLabel":"qi1pPfU"};